import React, { useEffect, useState } from 'react'
import { errorToast } from '../Common/showtoast';
import { useNavigate } from 'react-router-dom';
import ApiRequest from '../Common/restservice';

function Rankingincome() {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        GetTransactions();
    }, [])
    const GetTransactions = async () => {
        let res = await ApiRequest("GetIncomeReport.asp", "POST", { modes: "R" }, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setTableData(res.items);
    }
    return (
        <section className="content">
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                Ranking Income
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Username</th>
                                            <th>Package</th>
                                            <th>Payout</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="5">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.date}</td>
                                                        <td>{item.businessid}</td>
                                                        <td>{item.investment}</td>
                                                        <td>Rs. {item.payout}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Rankingincome
